/**
 * @class FullScreen
 * @classdesc API полноэкранного режима браузера
 * @memberof module:layout
 * @abstract
 */
class FullScreen {

    /**
     * @member {boolean} module:layout.FullScreen.enabled Доступность полноэкранного режима
     * @readonly
     */
    static get enabled(){
        return !!(document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled);
    }

    /**
     * @member {boolean} module:layout.FullScreen.active Полноэкранный режим включен/выключен
     */
    static get active(){
        if (!this.enabled) return false;
        return !!(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement);
    }

    static set active(val){
        if (!this.enabled) return false;
        this.toggle(document.documentElement, !!val);
    }

    /**
     * Перевод страницы в полноэкранный режим
     * @alias module:layout.FullScreen.activate
     * @param {HTMLElement} element
     */
    static activate(element) {
        if (!this.enabled) return false;
        element = element || document.documentElement;
        if (element.requestFullscreen) element.requestFullscreen();
        if (element.webkitRequestFullscreen) element.webkitRequestFullscreen();
        if (element.mozRequestFullScreen) element.mozRequestFullScreen();
        if (element.msRequestFullscreen) element.msRequestFullscreen();
    }

    /**
     * Выход из полноэкранного режима
     * @alias module:layout.FullScreen.cancel
     */
    static cancel() {
        if (!this.enabled) return false;
        if (document.cancelFullScreen) document.cancelFullScreen();
        if (document.webkitCancelFullScreen) document.webkitCancelFullScreen();
        if (document.mozCancelFullScreen) document.mozCancelFullScreen();
        if (document.msExitFullscreen) document.msExitFullscreen();
        if (document.exitFullscreen) document.exitFullscreen();
    }

    /**
     * Переключение состояния полноэкранного режима
     * @alias module:layout.FullScreen.toggle
     * @param {HTMLElement} element
     * @param {boolean} [flag=!FullScreen.active]
     */
    static toggle(element, flag = !this.active) {
        if (!this.enabled) return false;
        if (flag) {
            this.activate(element);
        }
        else {
            this.cancel();
        }
    }


}

export default FullScreen;